import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export const tableHeaderCellVariant = cva(
  "text-left align-middle text-xs font-medium uppercase tracking-wide text-muted-foreground [&:has([role=checkbox])]:pr-0 bg-surface-4 sorted:bg-surface-2",
  {
    variants: {
      density: {
        compact: "h-8 px-2",
        default: "h-10 px-3",
        comfortable: "h-12 px-4",
      },
    },
    defaultVariants: {
      density: "default",
    },
  }
);

export const tableCellVariant = cva(
  "align-top [&:has([role=checkbox])]:pr-3 transition-colors group-hover:bg-surface-1 group-hover:selected:bg-accent-3A bg-surface-3 sorted:bg-surface-1 selected:bg-accent-1A",
  {
    variants: {
      density: {
        compact: "p-2",
        default: "p-3",
        comfortable: "p-4",
      },
    },
    defaultVariants: {
      density: "default",
    },
  }
);

export const tableRowVariant = cva(
  "border-b bg-card transition-colors data-[state=selected]:bg-muted group"
);

export type TableHeaderCellVariant = VariantProps<typeof tableHeaderCellVariant>;
export type TableCellVariant = VariantProps<typeof tableCellVariant>;
export type TableRowVariant = VariantProps<typeof tableRowVariant>;
